<template>
  <div>
    <h2>调整单详情</h2>
    <Form class="form-style">
        <div class="form-top">调整单: {{adjustSheetDetailData.adjustmentResultId}}</div>
        <div class="form-top">订单号: {{adjustSheetDetailData.orderNo}}</div>
        <div class="form-top">
          <span >入住单: {{adjustSheetDetailData.checkinId}}</span>
          <span style="margin-left:150px">房间: {{adjustSheetDetailData.roomId}}_{{adjustSheetDetailData.roomNo}}</span>
        </div>
        
        <div class="form-top">子入住单: {{adjustSheetDetailData.checkinInfoId}}</div>
        <div class="form-top">建单原因: {{adjustSheetDetailData.reason}}</div>
        <div class="form-top">复核备注:{{adjustSheetDetailData.reviewNote}}</div>
        <div class="form-top">审批备注:{{adjustSheetDetailData.approvalNote}}</div>
        <div class="form-top">
          <span>操作记录:</span>
          <span>{{adjustSheetDetailData.createDate}} | 创建调整单 | {{adjustSheetDetailData.createName}}</span>
          <div style="margin-left:60px;margin-top:6px" v-if="adjustSheetDetailData.reviewState">{{adjustSheetDetailData.reviewDate}} | 审批状态：{{reviewStateText[adjustSheetDetailData.reviewState]}} | {{adjustSheetDetailData.reviewerName}}</div>
          <div style="margin-left:60px;margin-top:6px" v-if="adjustSheetDetailData.approvalState">{{adjustSheetDetailData.approverDate}} | 审批状态：{{approvalStateText[adjustSheetDetailData.approvalState]}} | {{adjustSheetDetailData.approverName}}</div>
        </div>
        <div class="form-top">
          <span>审批状态: {{statusText[adjustSheetDetailData.audit]}}</span>
          <Button v-show="adjustSheetDetailData.audit===1" type="primary" class="btn-style" @click="adjustCheckBtn">复核</Button>
          <Button v-show="adjustSheetDetailData.audit===2" type="primary" class="btn-style" @click="adjustCheckBtn">审批</Button>
        </div>
        
      <!-- 表格 -->
      <div class="table-style">
        <Row>
        <Col span="8">
            <h3>原子入住单</h3>
        </Col>
        <Col span="8">
            <h3>调整为</h3>
        </Col>
        <Col span="8">
            <h3>差额</h3>
        </Col> 
      </Row>

      <Row class="top table-bgcolor">
        <Col span="8">
            <div>实际开始结束日期: {{adjustSheetDetailData.orgActualCheckintStart}}-{{adjustSheetDetailData.orgActualCheckoutEnd}}</div>
        </Col>
        <Col span="8">
            <div>{{adjustSheetDetailData.actualTimeStart}}-{{adjustSheetDetailData.actualTimeEnd}}</div>
        </Col>
        <Col span="8">
            <div>{{adjustSheetDetailData.roomNightDiff}} 房晚</div>
        </Col> 
      </Row>

      <Row class="top">
        <Col span="8">
            <div>房费原价: {{(adjustSheetDetailData.orgRoomPrice/100).toFixed(2)}}</div>
        </Col>
        <Col span="8">
            <div>{{(adjustSheetDetailData.roomPrice/100).toFixed(2)}}</div>
        </Col>
        <Col span="8">
            <div>{{(adjustSheetDetailData.roomPriceDiff/100).toFixed(2)}}</div>
        </Col>  
      </Row>
      
      <Row class="top table-bgcolor">
        <Col span="8">
            <div>业主优惠: {{(adjustSheetDetailData.orgOwnerBear/100).toFixed(2)}}</div>
        </Col>
        <Col span="8">
           <div>{{(adjustSheetDetailData.ownerBear/100).toFixed(2)}}</div>
        </Col>
        <Col span="8">
            <div>{{(adjustSheetDetailData.ownerBearDiff/100).toFixed(2)}}</div>
        </Col>         
      </Row>

      <Row class="top">
        <Col span="8">
            <div>Xbed优惠: {{(adjustSheetDetailData.orgXbedBear/100).toFixed(2)}}</div>
        </Col>
        <Col span="8">
            <div>{{(adjustSheetDetailData.xbedBear/100).toFixed(2)}}</div>
        </Col>
        <Col span="8">
            <div>{{(adjustSheetDetailData.xbedBearDiff/100).toFixed(2)}}</div>
        </Col>
      </Row>
      
      <Row class="top table-bgcolor">
        <Col span="8">
            <div>应付: {{(adjustSheetDetailData.orgShouldPay/100).toFixed(2)}}</div>
        </Col>
        <Col span="8">
            <div>{{(adjustSheetDetailData.shouldPay/100).toFixed(2)}}</div>
        </Col>
        <Col span="8">
            <div>{{(adjustSheetDetailData.shouldPayDiff/100).toFixed(2)}}</div>
        </Col> 
      </Row>

      <Row class="top">
        <Col span="8">
            <div>OTA佣金: {{(adjustSheetDetailData.orgChannelCommission/100).toFixed(2)}}</div>
        </Col>
        <Col span="8">
            <div>{{(adjustSheetDetailData.channelCommission/100).toFixed(2)}}</div>
        </Col>
        <Col span="8">
            <div>{{(adjustSheetDetailData.channelCommissionDiff/100).toFixed(2)}}</div>
        </Col>
      </Row>

      <Row class="top table-bgcolor">
        <Col span="8">
            <div>渠道活动费: {{(adjustSheetDetailData.orgOtherChannelExpenses/100).toFixed(2)}}</div>
        </Col>
        <Col span="8">
            <div>{{(adjustSheetDetailData.otherChannelExpenses/100).toFixed(2)}}</div>
        </Col>
        <Col span="8">
            <div>{{(adjustSheetDetailData.otherChannelExpensesDiff/100).toFixed(2)}}</div>
        </Col> 
      </Row>

      <Row class="top">
        <Col span="8">
            <div>业主推广费:{{(adjustSheetDetailData.orgOwnerPromotionExpense/100).toFixed(2)}}</div>
        </Col>
        <Col span="8">
            <div>{{(adjustSheetDetailData.ownerPromotionExpense/100).toFixed(2)}}</div>
        </Col>
        <Col span="8">
            <div>{{(adjustSheetDetailData.ownerPromotionExpenseDiff/100).toFixed(2)}}</div>
        </Col>  
      </Row>

      <Row class="top table-bgcolor">
        <Col span="8">
            <div>Xbed推广费:{{(adjustSheetDetailData.orgXbedPromotionExpense/100).toFixed(2)}}</div>
        </Col>
        <Col span="8">
            <div>{{(adjustSheetDetailData.xbedPromotionExpense/100).toFixed(2)}}</div>
        </Col>
        <Col span="8">
            <div>{{(adjustSheetDetailData.xbedPromotionExpenseDiff/100).toFixed(2)}}</div>
        </Col>
      </Row>

      <Row class="top">
        <Col span="8">
            <div>Xbed实收:{{(adjustSheetDetailData.orgReceivedPrice/100).toFixed(2)}}</div>
        </Col>
        <Col span="8">
            <div>{{(adjustSheetDetailData.receivedPrice/100).toFixed(2)}}</div>
        </Col>
        <Col span="8">
            <div>{{(adjustSheetDetailData.receivedPriceDiff/100).toFixed(2)}}</div>
        </Col> 
      </Row>

      <Row class="top table-bgcolor">
        <Col span="8">
            <div>结算房费:{{(adjustSheetDetailData.orgSettlementPrice/100).toFixed(2)}}</div>
        </Col>
        <Col span="8">
            <div>{{(adjustSheetDetailData.settlementPrice/100).toFixed(2)}}</div>
        </Col>
        <Col span="8">
            <div>{{(adjustSheetDetailData.settlementPriceDiff/100).toFixed(2)}}</div>
        </Col> 
      </Row>

      <Row class="top">
        <Col span="8">
            <div>平台服务费:{{(adjustSheetDetailData.orgPlatformPrice/100).toFixed(2)}}</div>
        </Col>
        <Col span="8">
            <div>{{(adjustSheetDetailData.platformPrice/100).toFixed(2)}}</div>
        </Col>
        <Col span="8">
            <div>{{(adjustSheetDetailData.platformPriceDiff/100).toFixed(2)}}</div>
        </Col>
      </Row>

      <Row class="top table-bgcolor">
        <Col span="8">
            <div>推广费返还:{{(adjustSheetDetailData.orgPromotionExpenseBack/100).toFixed(2)}}</div>
        </Col>
        <Col span="8">
            <div>{{(adjustSheetDetailData.promotionExpenseBack/100).toFixed(2)}}</div>
        </Col>
        <Col span="8">
            <div>{{(adjustSheetDetailData.promotionExpenseBackDiff/100).toFixed(2)}}</div>
        </Col>
      </Row>
      </div>
      
    </Form>

    <!-- 弹窗 -->
    <Modal v-model="reviewModal.display" :title="reviewModal.audit === 2?'调整单审批':'调整单复核'" :loading="modalLoading" @on-ok="submitBtn" ok-text="提交">
      <Form :label-width="80" :model="reviewModal">
        <FormItem label="调整单号">
          <span>{{reviewModal.adjustmentResultId}}</span>
        </FormItem>
        <FormItem label="审批状态">
          <Select v-show="reviewModal.audit===2" v-model="reviewModal.reviewState" class="select-style">
            <Option :value="2">审批通过</Option>
            <Option :value="3">取消(不通过)</Option>
          </Select>
          <Select v-show="reviewModal.audit===1" v-model="reviewModal.reviewState" class="select-style">
            <Option :value="2">复核通过</Option>
            <Option :value="3">取消(不通过)</Option>
          </Select>
        </FormItem>
        <FormItem label="备注">
          <Input v-model="reviewModal.reviewNote" type ="textarea" :autosize="{minRows: 2,maxRows: 5}" :maxlength="500" placeholder=""></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import Utils from "@/utils";
import API from "@/api";
import moment from "moment";
import {STORE_KEY} from "../../constants";
export default {
  created() {
      this.token = Utils.findFromLocalStorage("vue-token");
      this.env = Utils.findFromLocalStorage("env", "dev");
      this.username = Utils.findFromLocalStorage("vue-username");
      // 获取文章调整单号
    this.adjustmentResultId = Utils.getUrlParameterByName("adjustmentResultId");
    },
  mounted(){
     this.$Notice.config({
      top: 200
    });
    this.getadjustmentInfoDetail()
  },
  data(){
    return{
      modalLoading:false,
      approvalStateText:['','未审批','审批通过','已取消'],
      reviewStateText:['','未审核','复核通过','已取消'],
      adjustSheetDetailData:{},
      // 状态弹窗
      reviewModal:{
        display:false,
        reviewState:2
      },
      // modalLoading:true,
      statusText:['','待复核','待审批','审批通过','取消'],
      status:1
    }    
  },
  methods:{
    // 权限校验
    checkHasPermission(name) {
      if(!Utils.hasPermission(name)){
        this.$Notice.error({
          title: Utils.getFromStore(STORE_KEY.STORE_KEY_NOT_PERMISSION_TIPS)
        });

        return false;
      }
      return true;
    },
    // 调整单详情列表
    async getadjustmentInfoDetail(){
      const parmas={
        adjustmentResultId:this.adjustmentResultId
      }
      const resp = (await API.omsAPI[this.env].order.getAdjustmentDetail(
      parmas,
      this.token
    )).data;
    if(resp.retCode){
      this.$Notice.error({
        title: '获取调整单详情失败',
        desc: resp.msg
      })
      return
    } else {
      this.adjustSheetDetailData = resp
      this.adjustSheetDetailData.reviewDate=moment(resp.reviewDate).format('YYYY-MM-DD HH:mm:ss')
      this.adjustSheetDetailData.approverDate=moment(resp.approverDate).format('YYYY-MM-DD HH:mm:ss')

      this.adjustSheetDetailData.actualTimeStart =resp.actualCheckinTime!==null? moment(resp.actualCheckinTime).format('YYYY.MM.DD'):''//调整实际开始时间
      this.adjustSheetDetailData.actualTimeEnd =resp.actualCheckoutTime!==null? moment(resp.actualCheckoutTime).format('YYYY.MM.DD'):''//调整实际结束时间

      this.adjustSheetDetailData.orgActualCheckintStart =resp.orgActualCheckinTime!==null?moment(resp.orgActualCheckinTime).format('YYYY.MM.DD'):''//原始实际开始时间
      this.adjustSheetDetailData.orgActualCheckoutEnd =resp.orgActualCheckoutTime!==null? moment(resp.orgActualCheckoutTime).format('YYYY.MM.DD'):''//原始实际结束时间
      }
    },
    adjustCheckBtn(){
      this.reviewModal.adjustmentResultId=this.adjustmentResultId
      this.reviewModal.audit=this.adjustSheetDetailData.audit
      this.reviewModal.reviewNote = ''
      this.reviewModal.display=true
    },
    async submitBtn(){
      if(this.reviewModal.audit === 1){
        if (!this.checkHasPermission('oms_adjustment_review')) {
          return;
         }
        const params ={
          adjustmentResultId:this.reviewModal.adjustmentResultId,
          operator:this.username,
          reviewNote:this.reviewModal.reviewNote||'',
          reviewState:this.reviewModal.reviewState
        }
        const resp = (await API.omsAPI[this.env].order.getAdjustmentReview(
        params,
        this.token
      )).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '复核失败',
          desc: resp.msg
        })
        return
      } else {
        this.modalLoading=false
        this.$Notice.success({
          title: '复核成功'
        })
        this.getadjustmentInfoDetail()
        
        }
      } 
      if(this.reviewModal.audit === 2) {
        if (!this.checkHasPermission('oms_adjustment_approval')) {
          return;
          }
        const secondParams = {
          adjustmentResultId:this.reviewModal.adjustmentResultId,
          approvalNote:this.reviewModal.reviewNote||'',
          approvalState:this.reviewModal.reviewState,
          operator:this.username,
        }
        const resp = (await API.omsAPI[this.env].order.getAdjustmentApproval(
        secondParams,
        this.token
      )).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '审批失败',
          desc: resp.msg
        })
        return
      } else {
        this.modalLoading=false
        this.$Notice.success({
          title: '审批成功',
          desc: resp.msg
        })
        this.getadjustmentInfoDetail()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .form-style{
    margin-top: 10px;
    .btn-style{
    margin-left: 30px
  }
  }
  .table-style{
     width: 1000px;
     border:1px solid rgb(56, 55, 55);
     margin:10px;
     padding:10px;
  }
  .top{
    margin-top: 14px;
  }
  .form-top{
    margin-top: 14px;
  }
  .table-bgcolor{
    background: #F7F7F7
  }
</style>




// WEBPACK FOOTER //
// src/pages/adjustment-sheet/adjustment-order-detail.vue